import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 bg-dark-900 border-t border-gray-800 mt-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">

        <div>
          <h3 className="text-2xl font-bold text-white mb-3">ORBTX</h3>
          <p className="text-gray-400 max-w-md leading-relaxed">
            ORBTX is building foundational infrastructure for AI-driven orbital
            optimization and mission intelligence.
            Professional orbital transfer infrastructure for the new space era.
          </p>
        </div>

        <div className="flex flex-col gap-3 text-sm">
          <a
            href="/api/docs"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition-colors"
          >
            API Documentation
          </a>

          <a
            href="mailto:marzhannurbakyt@gmail.com"
            className="text-gray-400 hover:text-white transition-colors"
          >
            Contact
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-gray-800 text-center text-xs text-gray-500">
        © 2026 ORBTX. Infrastructure for orbital intelligence.
      </div>
    </footer>
  );
};

export default Footer;